import $ from 'jquery';

const $banner = $('#top-banner');
const $headerOffcanvas = $('#header-offcanvas');

function updateHeaderMargin(): void {
  if ($(window).width()! < 768 && $banner.length && $headerOffcanvas.length) {
    const marginTop = $banner.css('display') !== 'none' ? `${$banner.outerHeight()}px` : '0px';
    $headerOffcanvas.css('marginTop', marginTop);
  } else if ($headerOffcanvas.length) {
    $headerOffcanvas.css('marginTop', '0px');
  }
}

updateHeaderMargin();
$(window).on('bannerClosed', updateHeaderMargin);
$(window).on('load', updateHeaderMargin);
$(window).on('resize', updateHeaderMargin);
